<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'FacebookMixin',

        data() {
            return {
                clientId: process.env.VUE_APP_FACEBOOK_CLIENT_ID,
                apiUrl: process.env.VUE_APP_SEEKER_API_URL,
                is_register: false,
            };
        },

        computed: {
            getLogo() {
                return `${
                    process.env.VUE_APP_URL
                }${require('@/assets/img/facebook.svg')}`;
            },
        },

        async mounted() {
            await this.loadFacebookSDK(document, 'script', 'facebook-jssdk');
            await this.initFacebook();
        },

        methods: {
            ...mapActions('auth', {
                $_facebookLogin: 'facebookLogin',
            }),

            afterLogin() {},

            handleFacebookLogin() {
                window.FB.login(
                    response => {
                        if (response.authResponse) {
                            const data = {
                                token: response.authResponse.accessToken,
                                provider: 'facebook',
                                register: true,
                            };
                            this.$_facebookLogin(data)
                                .then(response => {
                                    this.afterLogin(response);
                                })
                                .catch(error => {
                                    this.$emit(
                                        'onError',
                                        error.response.data.message,
                                    );
                                });
                        }
                    },
                    {
                        scope: 'email',
                        return_scopes: true,
                    },
                );
                return false;
            },

            async initFacebook() {
                window.fbAsyncInit = () => {
                    window.FB.init({
                        appId: this.clientId,
                        cookie: true,
                        xfbml: true,
                        version: 'v9.0',
                    });
                };
            },

            async loadFacebookSDK(d, s, id) {
                let js;
                let fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {
                    return;
                }
                js = d.createElement(s);
                js.id = id;
                js.src = 'https://connect.facebook.net/en_US/sdk.js';
                fjs.parentNode.insertBefore(js, fjs);
            },
        },
    };
</script>